import React, { useState } from 'react';
import 'intersection-observer'; // polyfill
import Observer from '@researchgate/react-intersection-observer';
import InfiniteScroll from 'react-infinite-scroller';

const DOMINIO_API = 'https://www.baixecatalogo.com.br/api/v1';
const DOMINIO_IMAGENS = 'https://www.baixecatalogo.com.br';
let pagina = 0;
const LIMIT_PAGINA = 10;
const PATH_CATALOGOS = '/exibe-no-site-ideia';
const URL_BUSCA_BAIXE_CATALOGO = 'https://baixecatalogo.com.br/busca';
const URL_CATALOGO_BAIXE_CATALOGO = 'https://baixecatalogo.com.br/catalogo/';
const IMAGE_INITIAL = 'data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAAALAAD/7gAhQWRvYmUAZMAAAAABAwAQAwIDBgAAAoMAAAKPAAACtf/bAIQAFBAQGBEYJxcXJzElHiUxLSYlJSYtPTQ0NDQ0PURAQEBAQEBERERERERERERERERERERERERERERERERERERERAEVGBggGyAmGBgmNSYgJjVENSoqNUREREE0QURERERERERERERERERERERERERERERERERERERERERERERERERE/8IAEQgBLAEsAwEiAAIRAQMRAf/EAF4AAQEAAAAAAAAAAAAAAAAAAAAGAQEAAAAAAAAAAAAAAAAAAAAAEAEBAAAAAAAAAAAAAAAAAACAoBEBAAAAAAAAAAAAAAAAAAAAoBIBAAAAAAAAAAAAAAAAAAAAgP/aAAwDAQACEQMRAAAAswAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf/2gAIAQIAAQUANP8A/9oACAEDAAEFADT/AP/aAAgBAQABBQCaT//aAAgBAgIGPwA0/wD/2gAIAQMCBj8ANP8A/9oACAEBAQY/ADSf/9k=';

const downloadAtivo = (plataformas) => plataformas
  && plataformas.some((plat) => plat.download_ativo);

const handleIntersection = (event, cat) => {
  const logoPath = DOMINIO_IMAGENS + cat.imagens.logo;
  if (event.isIntersecting && event.target.src !== logoPath) {
    event.target.src = logoPath;
  }
};

const montaUrlCatalogo = (catalogo) => (catalogo.agrupa_catalogos
  ? `${URL_BUSCA_BAIXE_CATALOGO}?filtros=${encodeURIComponent(JSON.stringify([{ campoEnum: 'agrupa_catalogos', filtros: [catalogo.agrupa_catalogos] }]))}`
  : `${URL_CATALOGO_BAIXE_CATALOGO}${catalogo.id_nome}`);

const renderCatalogos = (catalogos) => catalogos.map((cat) => (
  <div key={cat._id} className="container-logo">
    {
      downloadAtivo(cat.plataformas)
        ? (
          <a
            href={montaUrlCatalogo(cat)}
            target="_blank"
            rel="noreferrer noopener"
            style={{ display: 'block' }}
          >
            <Observer onChange={(event) => handleIntersection(event, cat)}>
              <img
                src={IMAGE_INITIAL}
                alt={`logo ${cat.nome}`}
                className="logo-catalogo"
              />
            </Observer>
          </a>
        ) : (
          <Observer onChange={(event) => handleIntersection(event, cat)}>
            <img
              src={IMAGE_INITIAL}
              alt={`logo ${cat.nome}`}
              className="logo-catalogo"
            />
          </Observer>
        )
    }
  </div>
));

export default () => {
  const [catalogos, setCatalogos] = useState([]);
  const [temMaisCatalogos, setTemMaisCatalogos] = useState(true);

  const obtemCatalogos = () => {
    setTemMaisCatalogos(false);
    window.fetch(`${DOMINIO_API}${PATH_CATALOGOS}?offset=${pagina * LIMIT_PAGINA}&limit=${LIMIT_PAGINA}`)
      .then((response) => {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.indexOf('application/json') !== -1) {
          return response.json();
        }
        return [];
      })
      .then((catalogosRetornados) => {
        if (catalogosRetornados && catalogosRetornados.length) {
          // incrementa uma página
          pagina += 1;
          // indica que tem mais catalogos e carrega mais catálogos
          setTemMaisCatalogos(catalogosRetornados.length >= LIMIT_PAGINA);
          setCatalogos((catalogos) => catalogos.concat(catalogosRetornados));
        }
      });
  };

  return (
    <>
      <InfiniteScroll
        pageStart={0}
        loadMore={obtemCatalogos}
        hasMore={temMaisCatalogos}
        loader={<div className="loader" key={0}>Carregando ...</div>}
      >
        {
          catalogos && catalogos.length
            ? renderCatalogos(catalogos) : <div></div>
        }
      </InfiniteScroll>
    </>
  );
};
